import React from 'react'
import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from "@mui/material/CircularProgress"

import DropZone from '../../components/Dropzone'

import {Context as AppContext}  from '../../contexts/App'
import {Context as NotificationsContext}  from '../../contexts/Notifications'
import VendorPicker  from '../../components/vendorPicker'

const failedUpdateListings = 'Products-updateListings'
const Listings = () => {
	const { vendor, products} = React.useContext(AppContext)
	const [disabled, setDisabled] = React.useState(false)
	const [filesAmazon, setAmazonFiles] = React.useState([])
	const [filesMercado, setMercadoFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)
	React.useEffect(() => {
		setClear(true)
	}, [vendor])

	React.useEffect(() => {
		clear && setClear(false)
	}, [clear])

	const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)

	React.useEffect(() => {
		createSnack(failedUpdateListings, {message: "Falló la alta de productos"})
		return () => deleteSnack(failedUpdateListings)
	}, [])

	const onError = () => {
		enable()
		openSnack(failedUpdateListings)
	}

	
	const enable = () => {
		setDisabled(false)
		setClear(true)
	}

	const submitFile = e => {
		e.stopPropagation()
		setDisabled(true)
		const data = new FormData()
		const listings = vendor === 'amazon'? filesAmazon[0] : filesMercado[0]
		data.append("listings", listings)
		data.append("vendor", vendor)

		products.updateListings(data, enable, onError)
	}
	
	const flag = filesAmazon.length > 0 || filesMercado.length > 0

	return (
		<div style={{
			display: 'flex',
			justifyContent: "center",
			margin: 'auto',
			width: 400,
			flexWrap: 'wrap',
		}}>
			<div style={{ width: '100%', float: 'left' }}>
				<h3>Actualizar listado de productos</h3> <br />
			</div>
			<Paper sx={{ cursor: flag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
					
				<VendorPicker/>

				<Box sx={{display:vendor === 'amazon'?'block':'none'}}>
					<DropZone accept={['.tsv', '.txt']} setFiles={setAmazonFiles} clear={clear}/>
				</Box>
			
				<Box sx={{display:vendor === 'mercado'?'block':'none'}}>
					<DropZone accept={'.xlsx'} setFiles={setMercadoFiles} clear={clear}/>
				</Box>

				<Button disabled={!flag || disabled} onClick={submitFile} variant="contained" color="primary">
					{disabled?<CircularProgress size={27}/>:'Añadir productos nuevos'}
				</Button>
			</Paper>
		</div>
	)
}

export default Listings
